import { render, staticRenderFns } from "./ReviewYourAnswersNLC.vue?vue&type=template&id=2ef7d5c6"
import script from "./ReviewYourAnswersNLC.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersNLC.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports